import { createFileRoute } from '@tanstack/react-router';
import { BrandDetailPage } from '@/features/brand-research/BrandDetailPage';

export const Route = createFileRoute('/brands/$brandId')({
  component: BrandDetailPage,
});
